export const castAreaStringPropsToNumbers = (object, keys) => {
  return Object.fromEntries(
    Object.keys(object).map((key) => {
      return [key, keys.includes(key) ? Number(object[key]) : object[key]];
    })
  );
};

export const isInitialized = (area) => {
  return area.type !== undefined;
};

export const calculateDoorPanelArea = (area) => {
  return 1.6 * area.doors;
};

export const calculateWallArea = (area) => {
  return 2 * (area.width + area.length) * area.height;
};

export const calculateWindowFrameArea = (area) => {
  return 0.4 * area.windows;
};

export const calculateWindowPanelArea = (area) => {
  return 1.4 * area.windows;
};
